import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Nav from "@/sections/Nav";
import Hero from "@/sections/Hero";
import Credibility from "@/sections/Credibility";
import About from "@/sections/About";
import Programmes from "@/sections/Programmes";
import Approach from "@/sections/Approach";
import Clients from "@/sections/Clients";
import Benefits from "@/sections/Benefits";
import Mission from "@/sections/Mission";
import Contact from "@/sections/Contact";
import Footer from "@/sections/Footer";
import FloatingWhatsApp from "@/sections/FloatingWhatsApp";
import StickyMobile from "@/sections/StickyMobile";
import SprkBadge from "@/sections/SprkBadge";

const Home = () => {
  // Lightweight scroll-reveal observer
  useEffect(() => {
    const els = document.querySelectorAll(".reveal");
    if (!("IntersectionObserver" in window)) {
      els.forEach((e) => e.classList.add("is-visible"));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <div data-testid="ascentix-home" className="min-h-screen text-slate-900">
      <Nav />
      <main>
        <Hero />
        <Credibility />
        <About />
        <Programmes />
        <Approach />
        <Clients />
        <Benefits />
        <Mission />
        <Contact />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <StickyMobile />
      <SprkBadge />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-center" />
    </div>
  );
}

export default App;
